module.exports = __webpack_public_path__ + "static/media/welcome.d74a4c2b.png";